<template>
    <div class="EmployerDisplayAndEdit">
        <!--DISPLAY TABLE-->
        <b-container>
            <b-row style="overflow-x:auto;">
                <b-col cols="11">
                    <vuetable :fields="TableFields"
                              :data="TableData"
                              pagination-path=""
                              :api-mode="false"
                              class="vue-datatable"
                              :row-class="onRowClass">

                        <template slot="DetailView" scope="props">
                            <div class="DetailView">
                                <span class="underline pointer" @click="ShowDetailView(props.rowData)"><span v-html="props.rowData.Name"></span> <font-awesome-icon :icon="['fa', 'edit']" v-if="EditMode" /></span>
                            </div>
                        </template>
                    </vuetable>
                </b-col>
                <b-col cols="1">
                    <div v-if="EditMode && CheckPermission(EditPermission)" class="vert-icons">
                        <b-row>
                            <font-awesome-icon :icon="['fa', 'plus']" v-on:click="ShowAddEditEmployer()" class="pointer olive-green-text" />
                        </b-row>
                    </div>
                </b-col>
            </b-row>
        </b-container>

        <!--ADD AND EDIT AND DETAIL MODAL-->
        <b-modal ref="modal-Employer" size="lg" :title="ModalEmployerTitle" hide-footer>
            <b-container v-if="EditMode == false && TargetEmployer.Id">
                <b-row>
                    <b-col>
                        <h3>Employer Info</h3>
                        <p><span class="bold">Name: </span>{{TargetEmployer.Name}}</p>
                        <p><span class="bold">Type: </span>{{TargetEmployer.EmployerType}}</p>
                    </b-col>
                    <b-col>
                        <h3>Address</h3>
                        <p>{{TargetEmployer.Address.AddressLine1}}</p>
                        <p>{{TargetEmployer.Address.AddressLine2}}</p>
                        <p>{{TargetEmployer.Address.City}}, {{TargetEmployer.Address.StateAbbreviation}} {{TargetEmployer.Address.ZipCode}}</p>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <h3>Phone Number</h3>
                        <p><span class="bold">Main: </span>{{TargetEmployer.PhoneNumber.FormattedPhoneNumber}}</p>
                    </b-col>
                    <b-col>
                        <h3>Employment Details</h3>
                        <p><span class="bold">Start Date: </span>{{ formatDate(TargetEmployer.StartDate,'MM/DD/YY') }}</p>
                        <p><span class="bold">End Date: </span>{{ formatDate(TargetEmployer.EndDate,'MM/DD/YY') }}</p>
                    </b-col>
                </b-row>
                <b-row class="modal-btn-row">
                    <div class="modal-btn-row-div">
                        <b-button size="md" variant="secondary" @click="CancelEmployer()">
                            CLOSE
                        </b-button>
                    </div>
                </b-row>
            </b-container>
            <b-container v-if="EditMode">
                <b-form @submit="AddEditEmployer" autocomplete="off">
                    <b-row>
                        <b-col>
                            <h3>Employer Info</h3>
                            <div class="form-group">
                                <label>Employer Name:</label>
                                <input type="text" class="form-control" v-model="TargetEmployer.Name" />
                            </div>
                            <div class="form-group">
                                <label>Employer Type:</label>
                                <select type="text" class="form-control" v-model="TargetEmployer.EmployerType">
                                    <option value="Part Time">Part Time</option>
                                    <option value="Full Time">Full Time</option>
                                    <option value="Unemployed">Unemployed</option>
                                </select>
                            </div>
                        </b-col>
                        <b-col>
                            <h3>Address</h3>
                            <div class="form-group">
                                <label>Address Line 1:</label>
                                <input type="text" class="form-control" v-model="TargetEmployer.Address.AddressLine1" />
                            </div>
                            <div class="form-group">
                                <label>Address Line 2:</label>
                                <input type="text" class="form-control" v-model="TargetEmployer.Address.AddressLine2" />
                            </div>
                            <div class="form-group">
                                <label>City:</label>
                                <input type="text" class="form-control" v-model="TargetEmployer.Address.City" />
                            </div>
                            <div class="form-group">
                                <label>State:</label>
                                <select class="form-control" v-model="TargetEmployer.Address.StateAbbreviation">
                                    <option v-for="option in StateOptions" :value="option.value">
                                        {{option.text}}
                                    </option>
                                </select>
                            </div>
                            <div class="form-group">
                                <label>Zip Code:</label>
                                <input type="number" class="form-control" v-model="TargetEmployer.Address.ZipCode" />
                            </div>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col>
                            <h3>Phone Number</h3>
                            <div class="form-group">
                                <label>Main Phone Number:</label>
                                <input type="text" class="form-control" v-model="TargetEmployer.PhoneNumber.PhoneNumberDigits" />
                            </div>
                        </b-col>
                        <b-col>
                            <h3>Employment Details</h3>
                            <div class="form-group">
                                <label>Start Date:</label>
                                <flat-pickr v-model="TargetEmployer.StartDate" class="form-control" required :config="DateConfig"></flat-pickr>
                            </div>
                            <div class="form-group">
                                <label>End Date:</label>
                                <flat-pickr v-model="TargetEmployer.EndDate" class="form-control" :config="DateConfig"></flat-pickr>
                            </div>
                        </b-col>
                    </b-row>
                    <b-row class="modal-btn-row">
                        <div class="modal-btn-row-div">
                            <b-button size="md" variant="secondary" @click="CancelEmployer()">
                                CANCEL
                            </b-button>
                            <b-button size="md" variant="success" type="submit" v-if="EditMode">
                                SAVE
                            </b-button>
                            <b-button size="md" variant="danger" @click="DeleteEmployer()" type="button" v-if="TargetEmployer.Id">
                                DELETE
                            </b-button>
                        </div>
                    </b-row>
                </b-form>
            </b-container>
        </b-modal>
    </div>

</template>

<script>
    //import icons
    import { library } from '@fortawesome/fontawesome-svg-core';
    import { faEdit } from '@fortawesome/free-solid-svg-icons';
    library.add(faEdit);
    import { faPlus } from '@fortawesome/free-solid-svg-icons';
    library.add(faPlus);
    import { faTrashAlt } from '@fortawesome/free-solid-svg-icons';
    library.add(faTrashAlt);
    import flatPickr from 'vue-flatpickr-component';
    import 'flatpickr/dist/flatpickr.css';

    import Vuetable from 'vuetable-2/src/components/Vuetable';
    import { EventBus } from '../../../services/event-bus.js';

    export default {
        name: "EmployerDisplayAndEdit",
        props: [
            "EditMode",//bool
            "GlobalUpdate",//bool
            "GetEndpoint",//string
            "GetPayload",//object
            "AddEditEndpoint",//string
            "AddEditPayload",//object
            "DeleteEndpoint",//string
            "DeletePayload",//object
            "EditPermission"
        ],
        data: function () {
            return {
                TargetEmployer: {},
                CommonEmployerSelection: "",
                ModalEmployerTitle: "",
                LoadedRecords: [],//Contact Membership Records
                EmployerSchema: {
                    StartDate: "",
                    EndDate: "",
                    Name: "",
                    EmployerType: "",
                    Address: {
                        AddressLine1: "",
                        AddressLine2: "",
                        City: "",
                        StateAbbreviation: "",
                        ZipCode: ""
                    },
                    PhoneNumber: {
                        PhoneNumberDigits: ""
                    }
                },
                DateConfig: {
                    dateFormat: 'Y-m-d',
                    allowInput: true,
                    altInput: true,
                    altFormat: 'm/d/Y',
                    required: false  
                }
                
            };
        },
        methods: {
            onRowClass (dataItem, index) {
                return (dataItem.EndDate == null) ? 'current-record' : '';
            },
            GetEmployers() {
                this.$MasterAPI.ExecuteRequest("GET", this.GetEndpoint, this.GetPayload, this.GetEmployersSuccess, () => { },false)
            },
            GetEmployersSuccess(response) {
                this.LoadedRecords = response.data.data;
            },
            ShowDetailView(Employer) {
                this.TargetEmployer = JSON.parse(JSON.stringify(Employer));
                
                if (this.EditMode) {
                    this.ModalEmployerTitle = "Editing " + Employer.Name;
                } else {
                    this.ModalEmployerTitle = "Viewing " + Employer.Name;
                }
                this.$refs["modal-Employer"].show();
            },
            ShowAddEditEmployer() {
                this.TargetEmployer = JSON.parse(JSON.stringify(this.EmployerSchema));
                this.ModalEmployerTitle = "Add New Employer";
                this.CommonEmployerSelection = "";
                this.$refs["modal-Employer"].show();
            },
            AddEditEmployer(e) {
                e.preventDefault();
                //get person data here
                this.$MasterAPI.ExecuteRequest("POST", this.AddEditEndpoint, { ...this.TargetEmployer, ...this.AddEditPayload }, this.AddEditEmployerSuccess, () => { }, true);
            },
            AddEditEmployerSuccess(response) {
                this.GetEmployers();
                this.$refs["modal-Employer"].hide();
            },
            DeleteEmployer() {
                this.$MasterAPI.ExecuteRequest("POST", this.DeleteEndpoint, { Id: this.TargetEmployer.Id }, this.DeleteEmployerSuccess, () => { }, true);
            },
            DeleteEmployerSuccess(response) {
                this.GetEmployers();
                this.$refs["modal-Employer"].hide();
            },
            CancelEmployer() {
                this.$refs['modal-Employer'].hide();
            },
            PrefillEmployerData() {
                this.TargetEmployer = this.CommonEmployers[this.CommonEmployerSelection];
            },
            formatDate (value, fmt = 'D MMM YYYY') {
              return (value == null || value == '')
                ? ''
                : moment(value, 'YYYY-MM-DD').format(fmt)
            },
            CheckPermission(permissionName) {
                return this.$store.getters["User.PrivateProfile.CheckPermission"](permissionName);
            },
        },
        components: {
            flatPickr,
            Vuetable
        },
        computed: {
            TableFields: function () {
                let vm = this;
                let fieldData = [
                    {
                        name: "__slot:DetailView",
                        title: "NAME"
                    },
                    {
                        name: "Address.City",
                        title: "LOCATION"
                    },
                    {
                        name: "EmployerType",
                        title: "TYPE"
                    },
                    {
                        name: "StartDate",
                        title: "STARTED",
                        callback: 'formatDate|MM/DD/YY',
                    },
                    {
                        name: "EndDate",
                        title: "ENDED",
                        callback: 'formatDate|MM/DD/YY',
                    }
                ];
                return fieldData;
            },
            TableData: function () {
                return this.LoadedRecords;
            },
            StateOptions: function () {
                return this.$store.state.Options.USStateAbbreviations;
            },
        },
        mounted() {
            this.GetEmployers();
            this.TargetEmployer = this.EmployerSchema;
        }
    }
</script>

<style scoped>
    .vert-icons div {
        margin-top:10px;
    }
    /deep/ tbody tr.current-record {
        font-weight: bold;
    }
    table {
        table-layout:auto;
    }
    .vue-datatable {
        width: 100%;
        display: inline-table;
        overflow-x: auto;
    }
</style>